
import { ProfileModel } from '../../../modules/profile/model/profile.model';
import { Templates } from './templates';
import { IRenderer } from '../renderer';

export class ProfileRenderer implements IRenderer {
  RenderHeader(preview: any) {
    if (preview as ProfileModel) {
      const profile = preview as ProfileModel;

      if (profile.fullName) { return '<b>' + profile.fullName + '</b>'; }

      return '<b>' + profile.userName + '</b>';
    }

    return '<b>invalid databinding</b>';
  }

  RenderBody(preview: any) {
    let html = '<ul class="bulletless">';
    if (preview as ProfileModel) {
      const profile = preview as ProfileModel;
      html += Templates.listItem('Felhasználó:', profile.userName);
      html += Templates.listItem('Email cím:', '<a href="mailto:' + profile.emailAddress + '">' + profile.emailAddress + '</a>');
      if (profile.phoneNumber) { html += Templates.listItem('Telefonszám:', '<a href="tel:' + profile.phoneNumber + '">' + profile.phoneNumber + '</a>'); }
    }
    html += '</ul>';
    return html;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/renderers/profile.renderer.ts